module.exports = __webpack_public_path__ + "static/media/stockhausen_mainz_24.34451212.jpg";